module.exports = __webpack_public_path__ + "static/img/23.3b8ece9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/23.png
// module id = NZyO
// module chunks = 0